import { useState, useEffect, useRef } from "react";
import { Card } from "@/components/ui/card";
import { Package } from "lucide-react";
export default function AbsoluteConsolidation() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  const topItems = [{
    label: "Cash drawer"
  }, {
    label: "Card reader"
  }, {
    label: "Package tracker"
  }, {
    label: "Manual spreadsheets"
  }, {
    label: "Staff selling"
  }];
  const bottomItems = [{
    label: "Instant digital payments"
  }, {
    label: "One tap scan"
  }, {
    label: "Auto-deduct sessions"
  }, {
    label: "Real-time dashboard"
  }, {
    label: "Silent checkout"
  }];
  return <section style={{
    backgroundColor: "rgb(255, 255, 255)",
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    paddingTop: "96px",
    paddingBottom: "96px",
    animation: "none 0s ease 0s 1 normal none running"
  }}>
      <div className="page-container">
        <div ref={ref} className={`transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="flex flex-col items-center text-center mb-10">
            <span className="mb-2" style={{
            color: "#C8985C",
            fontSize: "12px",
            fontWeight: "600",
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
          }}>
              ABSOLUTE CONSOLIDATION
            </span>
            <h2 style={{
            color: "rgb(31, 58, 46)",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "36px",
            fontWeight: "400",
            lineHeight: "40px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            textAlign: "center",
            animation: "none 0s ease 0s 1 normal none running",
            maxWidth: "560px"
          }}>
              One QR code replaces your cash drawer, card reader, and package
              tracker.
            </h2>
          </div>

          <div className="w-full overflow-hidden" style={{
          backgroundColor: "rgb(248, 247, 244)",
          border: "1px solid rgba(165, 174, 167, 0.3)",
          borderRadius: "16px",
          boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
          padding: "32px",
          maxWidth: "900px",
          marginLeft: "auto",
          marginRight: "auto"
        }}>
            <div className="grid" style={{
            gridTemplateColumns: "repeat(5, 1fr)"
          }}>
              {topItems.map((item, i) => <div key={i} className="flex flex-col items-center justify-start text-center" style={{
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRight: i < topItems.length - 1 ? "1px solid rgba(165, 174, 167, 0.25)" : "none",
              paddingLeft: "8px",
              paddingRight: "8px"
            }}>
                  <div className="flex items-center justify-center mb-3" style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "rgba(229, 62, 62, 0.12)",
                flexShrink: 0
              }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M4 4L14 14M14 4L4 14" stroke="#E53E3E" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                  </div>
                  <span style={{
                fontSize: "13px",
                fontWeight: "600",
                color: "#1F3A2E",
                lineHeight: "1.4"
              }}>
                    {item.label}
                  </span>
                </div>)}
            </div>

            <div style={{
            height: "1px",
            backgroundColor: "rgba(165, 174, 167, 0.3)",
            width: "100%"
          }} />

            <div className="grid" style={{
            gridTemplateColumns: "repeat(5, 1fr)"
          }}>
              {bottomItems.map((item, i) => <div key={i} className="flex flex-col items-center justify-start text-center" style={{
              paddingTop: "24px",
              paddingBottom: "24px",
              borderRight: i < bottomItems.length - 1 ? "1px solid rgba(165, 174, 167, 0.25)" : "none",
              paddingLeft: "8px",
              paddingRight: "8px"
            }}>
                  <div className="flex items-center justify-center mb-3" style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                backgroundColor: "#2F7D52",
                flexShrink: 0
              }}>
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.5 9L7.5 13L14.5 5.5" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </div>
                  <span style={{
                fontSize: "13px",
                fontWeight: "700",
                color: "#1F3A2E",
                lineHeight: "1.4"
              }}>
                    {item.label}
                  </span>
                </div>)}
            </div>
          </div>

          <div className="flex justify-center mt-5">
            <p style={{
            fontSize: "14px",
            fontStyle: "italic",
            fontWeight: "400",
            color: "oklch(55% 0.006 155)",
            textAlign: "center",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"'
          }}>
              &ldquo;Never chase a no-show check again.&rdquo;
            </p>
          </div>
        </div>
      </div>
    </section>;
}